import request from '@/utils/request'

// ==================== 认证相关 ====================
export function login(data) {
	return request({
		url: '/auth/login',
		method: 'post',
		data
	})
}

export function getInfo() {
	return request({
		url: '/auth/info',
		method: 'get'
	})
}

export function getCaptcha() {
	return request({
		url: '/auth/captcha',
		method: 'get'
	})
}

// ==================== 微信服务号绑定 ====================
export function getWechatBindTicket(ticket) {
	return request({
		url: '/wechat/bind/ticket',
		method: 'get',
		params: { ticket }
	})
}

export function bindWechat(data) {
	return request({
		url: '/wechat/bind',
		method: 'post',
		data
	})
}

export function unbindWechat() {
	return request({
		url: '/wechat/bind',
		method: 'delete'
	})
}

// ==================== 个人中心 ====================
export function updateProfile(data) {
	return request({
		url: '/auth/profile',
		method: 'put',
		data
	})
}

export function changePassword(data) {
	return request({
		url: '/auth/password',
		method: 'put',
		data
	})
}

// ==================== 仪表盘 ====================
export function getDashboardStats() {
	return request({
		url: '/dashboard/stats',
		method: 'get'
	})
}

// ==================== 用户管理 ====================
export function getUserPage(params) {
	return request({
		url: '/system/user/page',
		method: 'get',
		params
	})
}

export function getUser(id) {
	return request({
		url: '/system/user/' + id,
		method: 'get'
	})
}

export function addUser(data) {
	return request({
		url: '/system/user',
		method: 'post',
		data,
		params: data.roleIds && data.roleIds.length > 0 ? {
			roleIds: data.roleIds.join(',')
		} : {}
	})
}

export function updateUser(data) {
	return request({
		url: '/system/user',
		method: 'put',
		data,
		params: data.roleIds && data.roleIds.length > 0 ? {
			roleIds: data.roleIds.join(',')
		} : {}
	})
}

export function deleteUser(id) {
	return request({
		url: '/system/user/' + id,
		method: 'delete'
	})
}

export function resetPassword(id) {
	return request({
		url: '/system/user/' + id + '/reset-password',
		method: 'put'
	})
}

// ==================== 角色管理 ====================
export function getRoleList() {
	return request({
		url: '/system/role/list',
		method: 'get'
	})
}

export function getRolePage(params) {
	return request({
		url: '/system/role/page',
		method: 'get',
		params
	})
}

export function addRole(data, menuIds) {
	return request({
		url: '/system/role',
		method: 'post',
		data,
		params: menuIds ? {
			menuIds: menuIds.join(',')
		} : {}
	})
}

export function updateRole(data, menuIds) {
	return request({
		url: '/system/role',
		method: 'put',
		data,
		params: menuIds ? {
			menuIds: menuIds.join(',')
		} : {}
	})
}

export function deleteRole(id) {
	return request({
		url: '/system/role/' + id,
		method: 'delete'
	})
}

// ==================== 菜单管理 ====================
export function getMenuTree() {
	return request({
		url: '/system/menu/tree',
		method: 'get'
	})
}

export function getMenusByRole(roleId) {
	return request({
		url: '/system/menu/role/' + roleId,
		method: 'get'
	})
}

export function addMenu(data) {
	return request({
		url: '/system/menu',
		method: 'post',
		data
	})
}

export function updateMenu(data) {
	return request({
		url: '/system/menu',
		method: 'put',
		data
	})
}

export function deleteMenu(id) {
	return request({
		url: '/system/menu/' + id,
		method: 'delete'
	})
}

// ==================== 部门管理 ====================
export function getDeptTree(params) {
	return request({
		url: '/system/dept/tree',
		method: 'get',
		params
	})
}

export function addDept(data) {
	return request({
		url: '/system/dept',
		method: 'post',
		data
	})
}

export function updateDept(data) {
	return request({
		url: '/system/dept',
		method: 'put',
		data
	})
}

export function deleteDept(id) {
	return request({
		url: '/system/dept/' + id,
		method: 'delete'
	})
}

export function getDeptLeaderOptions() {
	return request({
		url: '/system/dept/leader-options',
		method: 'get'
	})
}

// ==================== 人员管理 ====================
export function getEmployeePage(params) {
	return request({
		url: '/personnel/page',
		method: 'get',
		params
	})
}

export function getEmployee(id) {
	return request({
		url: '/personnel/' + id,
		method: 'get'
	})
}

export function addEmployee(data) {
	return request({
		url: '/personnel',
		method: 'post',
		data: {
			...data,
			roleIds: data.roleIds && data.roleIds.length > 0 ? data.roleIds : undefined
		}
	})
}

export function updateEmployee(data) {
	return request({
		url: '/personnel',
		method: 'put',
		data: {
			...data,
			roleIds: data.roleIds && data.roleIds.length > 0 ? data.roleIds : undefined
		}
	})
}

export function deleteEmployee(id) {
	return request({
		url: '/personnel/' + id,
		method: 'delete'
	})
}

export function updateStatus(id, status) {
	return request({
		url: '/personnel/' + id + '/status',
		method: 'put',
		params: {
			status
		}
	})
}

// ==================== 采购管理 ====================
export function getOrderPage(params) {
	return request({
		url: '/procurement/page',
		method: 'get',
		params
	})
}

export function getOrder(id) {
	return request({
		url: '/procurement/' + id,
		method: 'get'
	})
}

export function createOrder(data) {
	return request({
		url: '/procurement',
		method: 'post',
		data
	})
}

export function updateOrder(id, data) {
	return request({
		url: '/procurement/' + id,
		method: 'put',
		data
	})
}

export function submitOrder(id) {
	return request({
		url: '/procurement/submit/' + id,
		method: 'put'
	})
}

export function approveOrder(id, data) {
	return request({
		url: '/procurement/' + id + '/approve',
		method: 'put',
		data
	})
}

export function executeOrder(id) {
	return request({
		url: '/procurement/' + id + '/execute',
		method: 'put'
	})
}

export function completeOrder(id) {
	return request({
		url: '/procurement/' + id + '/complete',
		method: 'put'
	})
}

export function returnOrder(id, data) {
	return request({
		url: '/procurement/' + id + '/return',
		method: 'put',
		data
	})
}

export function reviewOrder(id, data) {
	return request({
		url: '/procurement/' + id + '/review',
		method: 'put',
		data
	})
}

export function getApprovals(id) {
	return request({
		url: '/procurement/' + id + '/approvals',
		method: 'get'
	})
}

export function updateItemStatus(itemId, status, reason) {
	return request({ url: '/procurement/item/' + itemId + '/status', method: 'put', params: { status, reason } })
}

export function deleteOrder(id) {
	return request({
		url: '/procurement/' + id,
		method: 'delete'
	})
}

export function getReturnableOrders() {
	return request({
		url: '/procurement/returnable',
		method: 'get'
	})
}

// ==================== 公对公汇款记录 ====================
export function getProcurementRemittancePage(params) {
	return request({ url: '/procurement-remittances/page', method: 'get', params })
}

export function getProcurementRemittance(id) {
	return request({ url: '/procurement-remittances/' + id, method: 'get' })
}

export function getRemittanceSelectableOrders(keyword) {
	return request({ url: '/procurement-remittances/selectable-orders', method: 'get', params: { keyword } })
}

export function getRemittanceSelectableProjects() {
	return request({ url: '/procurement-remittances/selectable-projects', method: 'get' })
}

export function createProcurementRemittance(data) {
	return request({ url: '/procurement-remittances', method: 'post', data })
}

export function updateProcurementRemittance(id, data) {
	return request({ url: '/procurement-remittances/' + id, method: 'put', data })
}

export function deleteProcurementRemittance(id) {
	return request({ url: '/procurement-remittances/' + id, method: 'delete' })
}

export function exportProcurementRemittancesWord(params) {
	return request({ url: '/procurement-remittances/export-word', method: 'get', params, responseType: 'blob' })
}

export function exportProcurementRemittancesPdf(params) {
	return request({ url: '/procurement-remittances/export-pdf', method: 'get', params, responseType: 'blob' })
}

// ==================== 采购退货明细 ====================
export function getReturnPage(params) {
	return request({
		url: '/procurement/returns/page',
		method: 'get',
		params
	})
}

export function correctCompletedProcurementPrices(id, data) {
	return request({ url: '/procurement/' + id + '/completed-prices', method: 'put', data })
}

// ==================== 已完成采购明细 ====================
export function getCompletedProcurementItemPage(params) {
	return request({
		url: '/procurement/items/completed/page',
		method: 'get',
		params
	})
}

export function exportCompletedProcurementItemsWord(params) {
	return request({
		url: '/procurement/items/completed/export-word',
		method: 'get',
		params,
		responseType: 'blob'
	})
}

export function exportCompletedProcurementItemsPdf(params) {
	return request({
		url: '/procurement/items/completed/export-pdf',
		method: 'get',
		params,
		responseType: 'blob'
	})
}

// ==================== 临时入库/出库明细 ====================
export function getProcurementStockItemPage(stockType, params) {
	return request({
		url: '/procurement/items/stock/' + stockType + '/page',
		method: 'get',
		params
	})
}

export function exportProcurementStockItemsWord(stockType, params) {
	return request({
		url: '/procurement/items/stock/' + stockType + '/export-word',
		method: 'get',
		params,
		responseType: 'blob'
	})
}

export function exportProcurementStockItemsPdf(stockType, params) {
	return request({
		url: '/procurement/items/stock/' + stockType + '/export-pdf',
		method: 'get',
		params,
		responseType: 'blob'
	})
}

export function exportProcurementWord(id) {
	return request({ url: '/procurement/' + id + '/export-word', method: 'get', responseType: 'blob' })
}

export function getOrderReturns(id) {
	return request({
		url: '/procurement/' + id + '/returns',
		method: 'get'
	})
}

// ==================== 资产管理 ====================
export function getAssetTypes() {
  return request({ url: '/asset/types', method: 'get' })
}
export function getAssetCategories() {
  return request({ url: '/asset/categories', method: 'get' })
}
export function getAssetPage(params) {
  return request({ url: '/asset/page', method: 'get', params })
}
export function exportAssetExcel(params) {
  return request({ url: '/asset/export', method: 'get', params, responseType: 'blob', timeout: 120000 })
}
export function getAsset(id) {
  return request({ url: '/asset/' + id, method: 'get' })
}
export function addAsset(data) {
  return request({ url: '/asset', method: 'post', data })
}
export function updateAsset(data) {
  return request({ url: '/asset/' + data.id, method: 'put', data })
}
export function deleteAsset(id) {
  return request({ url: '/asset/' + id, method: 'delete' })
}
export function acquireAsset(id, data) {
  return request({ url: '/asset/' + id + '/acquire', method: 'post', data })
}
export function returnAsset(id, data) {
  return request({ url: '/asset/' + id + '/return', method: 'post', data })
}
export function scrapAsset(id) {
  return request({ url: '/asset/' + id + '/scrap', method: 'put' })
}
export function getAssetChangePage(params) {
  return request({ url: '/asset/changes/page', method: 'get', params })
}
export function getAssetChanges(id) {
  return request({ url: '/asset/' + id + '/changes', method: 'get' })
}
export function approveAssetChange(id, data) {
  return request({ url: '/asset/approve/' + id, method: 'put', data })
}

// ==================== 邮寄管理 ====================
export function getMailPage(params) {
	return request({
		url: '/mail/page',
		method: 'get',
		params
	})
}

export function getMail(id) {
	return request({
		url: '/mail/' + id,
		method: 'get'
	})
}

export function createMail(data) {
	return request({
		url: '/mail',
		method: 'post',
		data
	})
}

export function updateMail(id, data) {
	return request({
		url: '/mail/' + id,
		method: 'put',
		data
	})
}

export function submitMail(id) {
	return request({
		url: '/mail/submit/' + id,
		method: 'put'
	})
}

export function approveMail(id, data) {
	return request({
		url: '/mail/' + id + '/approve',
		method: 'put',
		data
	})
}

export function confirmMail(id, data) {
	return request({
		url: '/mail/' + id + '/confirm',
		method: 'put',
		data
	})
}

export function shipMail(id, data) {
	return request({
		url: '/mail/' + id + '/ship',
		method: 'put',
		data
	})
}

export function completeMail(id) {
	return request({
		url: '/mail/' + id + '/complete',
		method: 'put'
	})
}

export function getMailApprovals(id) {
	return request({
		url: '/mail/' + id + '/approvals',
		method: 'get'
	})
}

export function deleteMail(id) {
	return request({
		url: '/mail/' + id,
		method: 'delete'
	})
}

// ==================== 消息通知 ====================
export function getUnreadCount() {
	return request({
		url: '/notification/unread-count',
		method: 'get'
	})
}

export function getNotificationPage(params) {
	return request({
		url: '/notification/page',
		method: 'get',
		params
	})
}

export function markNotificationRead(id) {
	return request({
		url: '/notification/' + id + '/read',
		method: 'put'
	})
}

export function markAllRead() {
	return request({
		url: '/notification/read-all',
		method: 'put'
	})
}
// ==================== 操作日志 ====================
export function getLogPage(params) {
	return request({ url: '/system/log/page', method: 'get', params })
}

// ==================== 人员管辖 ====================
export function getSupervisorPage(params) {
	return request({ url: '/system/supervisor/page', method: 'get', params })
}
export function addSupervisor(data) {
	return request({ url: '/system/supervisor', method: 'post', data })
}
export function deleteSupervisor(id) {
	return request({ url: '/system/supervisor/' + id, method: 'delete' })
}

// ==================== 项目管理 ====================
export function getProjectPage(params) {
	return request({
		url: '/project/page',
		method: 'get',
		params
	})
}

export function getProject(id) {
	return request({
		url: '/project/' + id,
		method: 'get'
	})
}

export function addProject(data) {
	return request({
		url: '/project',
		method: 'post',
		data
	})
}

export function updateProject(id, data) {
	return request({
		url: '/project/' + id,
		method: 'put',
		data
	})
}

export function submitProject(id) {
	return request({
		url: '/project/submit/' + id,
		method: 'put'
	})
}

export function approveProject(id, data) {
	return request({
		url: '/project/' + id + '/approve',
		method: 'put',
		data
	})
}

export function terminateProject(id, data) {
	return request({
		url: '/project/' + id + '/terminate',
		method: 'put',
		data
	})
}

export function deleteProject(id) {
	return request({
		url: '/project/' + id,
		method: 'delete'
	})
}

export function getProjectApprovals(id) {
	return request({
		url: '/project/' + id + '/approvals',
		method: 'get'
	})
}

export function getActiveProjects() {
	return request({
		url: '/project/active',
		method: 'get'
	})
}

// ==================== 周报管理 ====================
export function getWeeklyReportPage(params) {
	return request({ url: '/report/weekly/page', method: 'get', params })
}
export function getWeeklyReport(id) {
	return request({ url: '/report/weekly/' + id, method: 'get' })
}
export function createWeeklyReport(data) {
	return request({ url: '/report/weekly', method: 'post', data })
}
export function updateWeeklyReport(id, data) {
	return request({ url: '/report/weekly/' + id, method: 'put', data })
}
export function submitWeeklyReport(id) {
	return request({ url: '/report/weekly/submit/' + id, method: 'put' })
}
export function publishWeeklyReport(data) {
	return request({ url: '/report/weekly/publish', method: 'post', data })
}
export function getDeptUsers() {
	return request({ url: '/report/weekly/dept-users', method: 'get' })
}
export function approveWeeklyReport(id, data) {
	return request({ url: '/report/weekly/' + id + '/approve', method: 'put', data })
}
export function scoreWeeklyReport(id, data) {
	return request({ url: '/report/weekly/' + id + '/score', method: 'put', data })
}
export function deleteWeeklyReport(id) {
	return request({ url: '/report/weekly/' + id, method: 'delete' })
}
export function addTasksToWeeklyReport(id, data) {
	return request({ url: '/report/weekly/' + id + '/add-tasks', method: 'post', data })
}
export function getExistingReports(userIds, weekStart) {
	return request({ url: '/report/weekly/existing-reports', method: 'get', params: { userIds, weekStart } })
}

// ==================== 月报管理 ====================
export function getMonthlyReportPage(params) {
	return request({ url: '/report/monthly/page', method: 'get', params })
}
export function getMonthlyReport(id) {
	return request({ url: '/report/monthly/' + id, method: 'get' })
}
export function updateMonthlyReport(id, data) {
	return request({ url: '/report/monthly/' + id, method: 'put', data })
}
export function completeMonthlyAssessment(id) {
	return request({ url: '/report/monthly/' + id + '/complete', method: 'put' })
}
export function deleteMonthlyReport(id) {
	return request({ url: '/report/monthly/' + id, method: 'delete' })
}

// ==================== 报销管理 ====================
export function getReimbursementPage(params) {
	return request({ url: '/reimbursement/page', method: 'get', params })
}
export function getReimbursement(id) {
	return request({ url: '/reimbursement/' + id, method: 'get' })
}
export function exportReimbursementWord(id) {
	return request({ url: '/reimbursement/' + id + '/export-word', method: 'get', responseType: 'blob' })
}
export function getReimbursementDetailPage(params) {
	return request({ url: '/reimbursement/details/page', method: 'get', params })
}
export function exportReimbursementDetailsWord(params) {
	return request({ url: '/reimbursement/details/export-word', method: 'get', params, responseType: 'blob' })
}
export function exportReimbursementDetailsPdf(params) {
	return request({ url: '/reimbursement/details/export-pdf', method: 'get', params, responseType: 'blob' })
}
export function createReimbursement(data) {
	return request({ url: '/reimbursement', method: 'post', data })
}
export function updateReimbursement(id, data) {
	return request({ url: '/reimbursement/' + id, method: 'put', data })
}
export function submitReimbursement(id) {
	return request({ url: '/reimbursement/submit/' + id, method: 'put' })
}
export function approveReimbursement(id, data) {
	return request({ url: '/reimbursement/' + id + '/approve', method: 'put', data })
}
export function payReimbursement(id, data) {
	return request({ url: '/reimbursement/' + id + '/pay', method: 'put', data })
}
export function deleteReimbursement(id) {
	return request({ url: '/reimbursement/' + id, method: 'delete' })
}
export function getReimbursementApprovals(id) {
	return request({ url: '/reimbursement/' + id + '/approvals', method: 'get' })
}

export function getProjectPrincipalOptions() {
	return request({
		url: '/project/principal-options',
		method: 'get'
	})
}

export function getProjectExpenditures(id) {
	return request({
		url: '/project/' + id + '/expenditures',
		method: 'get'
	})
}
export function getTravelSubsidyConfig() {
	return request({ url: '/reimbursement/travel-subsidy-config', method: 'get' })
}
export function getReimbursementTravelerOptions() {
	return request({ url: '/reimbursement/traveler-options', method: 'get' })
}

// 附件管理
export function uploadReimbursementAttachment(itemId, file) {
	const formData = new FormData()
	formData.append('file', file)
	return request({ url: '/reimbursement/item/' + itemId + '/upload', method: 'post', data: formData })
}
export function downloadReimbursementAttachment(id) {
	return '/api/reimbursement/attachment/' + id + '/download'
}
export function downloadReimbursementAttachmentBlob(id) {
	return request({
		url: '/reimbursement/attachment/' + id + '/download',
		method: 'get',
		responseType: 'blob'
	})
}
// Word转换可能超过普通请求的15秒超时，仅延长这个新接口的等待时间。
export function previewWordAttachmentBlob(module, id) {
	return request({
		url: '/' + module + '/attachment/' + id + '/preview-word',
		method: 'get',
		responseType: 'blob',
		timeout: 90000
	})
}
export function deleteReimbursementAttachment(id) {
	return request({ url: '/reimbursement/attachment/' + id, method: 'delete' })
}
export function getItemAttachments(itemId) {
	return request({ url: '/reimbursement/item/' + itemId + '/attachments', method: 'get' })
}

// ==================== 用章管理 ====================
export function getSealApplicationPage(params) {
	return request({ url: '/seal/page', method: 'get', params })
}
export function getSealProjectOptions() {
	return request({ url: '/seal/project-options', method: 'get' })
}
export function getSealApplication(id) {
	return request({ url: '/seal/' + id, method: 'get' })
}
export function createSealApplication(data) {
	return request({ url: '/seal', method: 'post', data })
}
export function updateSealApplication(id, data) {
	return request({ url: '/seal/' + id, method: 'put', data })
}
export function submitSealApplication(id) {
	return request({ url: '/seal/submit/' + id, method: 'put' })
}
export function approveSealApplication(id, data) {
	return request({ url: '/seal/' + id + '/approve', method: 'put', data })
}
export function deleteSealApplication(id) {
	return request({ url: '/seal/' + id, method: 'delete' })
}
export function getSealApplicationApprovals(id) {
	return request({ url: '/seal/' + id + '/approvals', method: 'get' })
}
export function uploadSealAttachment(itemId, file) {
	const formData = new FormData()
	formData.append('file', file)
	return request({ url: '/seal/item/' + itemId + '/upload', method: 'post', data: formData })
}
export function getSealItemAttachments(itemId) {
	return request({ url: '/seal/item/' + itemId + '/attachments', method: 'get' })
}
export function viewSealAttachmentBlob(id) {
	return request({ url: '/seal/attachment/' + id + '/view', method: 'get', responseType: 'blob' })
}
export function downloadSealAttachmentBlob(id) {
	return request({ url: '/seal/attachment/' + id + '/download', method: 'get', responseType: 'blob' })
}
export function deleteSealAttachment(id) {
	return request({ url: '/seal/attachment/' + id, method: 'delete' })
}

// ==================== 制度管理 ====================
export function getPolicyPage(params) {
	return request({ url: '/policy/page', method: 'get', params })
}
export function getPolicy(id) {
	return request({ url: '/policy/' + id, method: 'get' })
}
export function createPolicy(data) {
	return request({ url: '/policy', method: 'post', data })
}
export function updatePolicy(id, data) {
	return request({ url: '/policy/' + id, method: 'put', data })
}
export function publishPolicy(id) {
	return request({ url: '/policy/' + id + '/publish', method: 'put' })
}
export function offlinePolicy(id) {
	return request({ url: '/policy/' + id + '/offline', method: 'put' })
}
export function deletePolicy(id) {
	return request({ url: '/policy/' + id, method: 'delete' })
}
export function uploadPolicyAttachment(id, file) {
	const formData = new FormData()
	formData.append('file', file)
	return request({ url: '/policy/' + id + '/attachment', method: 'post', data: formData })
}
export function viewPolicyAttachmentBlob(id) {
	return request({ url: '/policy/attachment/' + id + '/view', method: 'get', responseType: 'blob' })
}
export function downloadPolicyAttachmentBlob(id) {
	return request({ url: '/policy/attachment/' + id + '/download', method: 'get', responseType: 'blob' })
}
export function deletePolicyAttachment(id) {
	return request({ url: '/policy/attachment/' + id, method: 'delete' })
}

// ==================== 官网留言 ====================
export function getWebsiteMessagePage(params) {
	return request({ url: '/website-messages/page', method: 'get', params })
}
export function getWebsiteMessage(id) {
	return request({ url: '/website-messages/' + id, method: 'get' })
}
export function processWebsiteMessage(id) {
	return request({ url: '/website-messages/' + id + '/process', method: 'put' })
}
export function completeWebsiteMessage(id, data) {
	return request({ url: '/website-messages/' + id + '/complete', method: 'put', data })
}

// 可关联的采购单（供报销关联使用）
export function getSelectableProcurementOrders() {
	return request({ url: '/procurement/selectable', method: 'get' })
}
